"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryWithQueryParameters = exports.parametersForCategoryEndpoint = void 0;
function parametersForCategoryEndpoint(parameters) {
    return Object.assign(Object.assign({}, categoryWithQueryParameters(parameters.with)), (parameters.includeHidden ? { showHidden: 'true' } : undefined));
}
exports.parametersForCategoryEndpoint = parametersForCategoryEndpoint;
function categoryWithQueryParameters(categoryWith) {
    var _a;
    if (!categoryWith) {
        return {
            depth: 1,
            with: 'properties:name()',
        };
    }
    const withParams = [];
    if (categoryWith.parents) {
        withParams.push('parents');
    }
    if (categoryWith.properties) {
        if (categoryWith.properties === 'all') {
            withParams.push('properties');
        }
        else {
            withParams.push(`properties:name(${categoryWith.properties.withName.join('|')})`);
        }
    }
    else {
        withParams.push('properties:name()');
    }
    if (categoryWith.children !== undefined && categoryWith.children > 0) {
        withParams.push('descendants');
    }
    return Object.assign(Object.assign({}, (withParams.length > 0 ? { with: withParams.join(',') } : undefined)), { depth: ((_a = categoryWith.children) !== null && _a !== void 0 ? _a : 0) + 1 });
}
exports.categoryWithQueryParameters = categoryWithQueryParameters;
